"use client";

import type { FC, ButtonHTMLAttributes } from "react";
import { cn } from "utils";
import { LoadingButton } from "@components/EmailLogin/LoadingButton";

export interface OnboardingEmphasisCtaButtonProps extends Pick<
  ButtonHTMLAttributes<HTMLButtonElement>,
  "onClick" | "type"
> {
  label: string;
  disabled?: boolean;
  loading?: boolean;
  testId?: string;
  sizeClassName?: "button_m" | "button_l";
  className?: string;
  openReplayLabel?: string;
}

/** Accent4 emphasis CTA (Result continue, Plan unlock) per Figma + `emphasis_button` shortcut */
export const OnboardingEmphasisCtaButton: FC<
  OnboardingEmphasisCtaButtonProps
> = ({
  label,
  disabled = false,
  loading = false,
  testId = "onboarding-emphasis-cta",
  sizeClassName = "button_m",
  className,
  openReplayLabel,
  onClick,
  type = "button",
}) => (
  <LoadingButton
    type={type}
    data-testid={testId}
    disabled={disabled}
    loading={loading}
    onClick={onClick}
    {...(openReplayLabel
      ? { "data-openreplay-label": openReplayLabel }
      : { "data-openreplay-label": testId })}
    className={cn(
      "button md_button emphasis_button w-full rounded-lg px-4 py-3",
      sizeClassName,
      className,
    )}
  >
    {label}
  </LoadingButton>
);
